import { CallApi } from '@signavio/kraken'

import { schema as userSchema } from './user'

export const collection = 'users'
export const schema = userSchema

type RemoveGroupMemberType = {
  groupId: string
  userId: string
}

type CreateGroupMemberType = {
  groupId: string
  userId: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { groupId, userId }: CreateGroupMemberType) =>
    callApi(`${apiBase}/groups/${groupId}/members`, schema, {
      method: 'POST',
      body: { id: userId },
    })

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ groupId, userId }: RemoveGroupMemberType) =>
    callApi(`${apiBase}/groups/${groupId}/members/${userId}`, schema, {
      method: 'DELETE',
    })

// disable optimisticRemove cache policy (which is the default)
// as we do not want to remove users when removing groupMembers
export const cachePolicy = {}
